import { defineStore } from "pinia";
import { BoardState } from "./types";
import { ref, computed, toRaw } from "vue";

const defaultBoardData = {
  id: 0,
  artworkId: 0,
  boardName: ""
};

export const useBoardCanvasStore = defineStore("infinite-canvas-board", () => {
  // #region State - 核心数据模型
  /**
   * 画板核心数据对象
   * 包含：ID、artworkId、boardName
   */
  const board = ref<BoardState>({ ...defaultBoardData });

  // #endregion

  // #region Getters - 业务属性访问
  const boardId = computed(() => board.value.id);
  const artworkId = computed(() => board.value.artworkId);
  const boardName = computed(() => board.value.boardName);

  // #endregion

  // #region Actions - 数据操作
  /**
   * 更新画板基本信息
   * @param newBoard 画板基本信息,有点坑,可能会有部分数据在这里
   */
  function setBoard(newBoard: Partial<BoardState>) {
    const currentBoard = toRaw(board.value);
    board.value = {
      ...currentBoard,
      ...newBoard
    };
  }

  /**
   * 重置画板到初始状态（清空数据、选中项等）
   */
  function reset() {
    board.value = { ...defaultBoardData };
  }

  // #endregion

  return {
    board,

    boardId,
    artworkId,
    boardName,

    setBoard,
    reset
  };
});
